var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-upload",
    {
      attrs: {
        action: "#",
        accept: ".jpg,.jpeg,.png,.gif,.webp",
        "show-file-list": false,
        disabled: _vm.uploading,
        "http-request": _vm.upload,
      },
    },
    [
      _c("el-button", { attrs: { size: "small", loading: _vm.uploading } }, [
        _vm._v("上传图片"),
      ]),
      _vm.value
        ? _c("img", { staticClass: "cover-thumb", attrs: { src: _vm.value } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }